import { useNavigate } from 'react-router-dom'
import { LinkObj } from '@plvs/respawn/renderController/appDrawer/types/appDrawerRenderController.types'
import { useProductTours } from '../../shepherd/utils/useProductTours'

export const useLink = (link: LinkObj): LinkObj => {
  const navigate = useNavigate()

  const { onboardingTour, findMatchTour } = useProductTours()

  const handleClick = (): void => {
    if (findMatchTour?.isActive()) {
      findMatchTour?.next()
      if (link.to) {
        navigate(link.to)
        return
      }
      return
    }

    if (onboardingTour?.isActive()) {
      onboardingTour?.next()
      if (link.to) {
        navigate(link.to)
        return
      }
      return
    }
    if (link.to) {
      navigate(link.to)
    }
  }

  return {
    ...link,
    handleOnClick: handleClick,
  }
}
